import { getDecoratedLibConfig } from '@cld/env-config';

//todo: we need to specify each env so @cld/env-config won't log a warning
const rawConfig = {
  production: {
    host: 'https://<%ENV_NAME%>cloudinary.com',
  },
  development: {
    host: 'https://<%ENV_NAME%>cloudinary.com',
  },
  staging: {
    host: 'https://<%ENV_NAME%>cloudinary.com',
  },
  nightly: {
    host: 'https://<%ENV_NAME%>cloudinary.com',
  },
};

export const getConfig = getDecoratedLibConfig(rawConfig) as (path: 'host' | 'mpeHost') => string;
